const isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
const isTouch = isBrowser && ('ontouchstart' in window || navigator.maxTouchPoints > 0);

export { isBrowser, isTouch };
